import { Grid2 as Grid, Typography, Box, Skeleton } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import StandardCard from '../ui/StandardCard';
import ErrorAlert from '../ui/ErrorAlert';
import { useFinanceDashboard } from '../../hooks/queries/useFinance';

const fmt = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v ?? 0);

export default function FinanceHeaderCards({ onMonthClick }) {
  const { data, isLoading, error } = useFinanceDashboard();

  if (error) return <ErrorAlert error={error.message} />;

  const periods = data?.periods ?? [];
  const current = data?.currentMonthLabel;

  const handleCardClick = (period) => {
    if (onMonthClick && period?.monthYear) {
      onMonthClick(period.monthYear);
    }
  };

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {(isLoading ? Array.from({ length: 4 }) : periods).map((p, i) => {
        const isCurrent = p?.label === current;
        return (
          <Grid key={p?.label ?? i} size={{ xs: 12, sm: 6, md: 3 }}>
            <StandardCard
              accentColor={isCurrent ? 'primary.main' : 'text.disabled'}
              fillHeight
              onClick={() => handleCardClick(p)}
              sx={{
                cursor: p ? 'pointer' : 'default',
                transition: 'all 0.2s ease',
                '&:hover': p ? {
                  boxShadow: 3,
                  transform: 'translateY(-2px)',
                  borderLeftColor: isCurrent ? 'primary.main' : 'primary.light',
                } : {},
              }}
            >
              <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  {isCurrent ? <AccountBalanceWalletIcon /> : <PaidOutlinedIcon />}
                  <Typography variant="subtitle2" textTransform="capitalize">
                    {p?.label || <Skeleton width={60} />}
                  </Typography>
                </Box>
                <Typography variant="caption" color="text.secondary">Bruto</Typography>
                <Typography variant="h6">{p ? fmt(p.gross) : <Skeleton width={100} />}</Typography>
                <Typography variant="caption" color="text.secondary">Líquido</Typography>
                <Typography variant="h6" color={isCurrent ? 'primary.main' : 'text.primary'}>
                  {p ? fmt(p.net) : <Skeleton width={100} />}
                </Typography>
              </Box>
            </StandardCard>
          </Grid>
        );
      })}
    </Grid>
  );
}
